module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/valais4you-german-f132648217801f58a12df1385958ad68.webp";